/**
 * Created by chenrozenes on 18/01/2017.
 */

import Podrick from '../tools/podrick';

export const { reducer, factory: PodrickFactory, sandbox } = Podrick();
